import { useEffect, useState } from 'react';
import { PaymentDetailModal } from '../../components/PaymentDetailModal';
import { PageHead, Tabs, Toolbar, Search, ListTable, Pager, CustomerCell, BankCell, StatusPill, ActBtn } from '../../components/list';
import { adminApi, type AdminPayment } from '../../api/admin';
import { money, dCell } from '../../components/format';
import { useAuth } from '../../auth/AuthContext';
import '../page.css';

const STATUS_TABS = [
  { key: '', label: 'Tümü' },
  { key: 'approved', label: 'Onaylı' },
  { key: 'pending', label: 'Bekleyen' },
  { key: 'failed', label: 'Başarısız' },
];

export function Payments() {
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';
  const [rows, setRows] = useState<AdminPayment[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [q, setQ] = useState('');
  const [status, setStatus] = useState('');
  const [busy, setBusy] = useState<number | null>(null);
  const [detailOrder, setDetailOrder] = useState<string | null>(null);

  const load = () => {
    const params = new URLSearchParams({ page: String(page) });
    if (q) params.set('q', q);
    if (status) params.set('status', status);
    adminApi.payments(params.toString()).then((r) => { setRows(r.payments); setTotal(r.total); });
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(load, [page, status]);

  const remove = async (p: AdminPayment) => {
    if (!window.confirm(`"${p.order_id}" ödeme kaydı kalıcı olarak silinecek. Emin misiniz?`)) return;
    setBusy(p.id);
    try { await adminApi.deletePayment(p.id); load(); } finally { setBusy(null); }
  };

  const pages = Math.max(1, Math.ceil(total / 20));

  return (
    <div className="page">
      <PageHead eyebrow="Yönetim" title="Ödeme Yönetimi" sub="Tüm tahsilatları filtreleyin ve inceleyin." />

      <Tabs tabs={STATUS_TABS} value={status} onChange={(k) => { setStatus(k); setPage(1); }} />

      <Toolbar>
        <Search value={q} onChange={setQ} onEnter={() => { setPage(1); load(); }} placeholder="Sipariş no / bayi ara…" />
        <span className="lt-grow" />
        <span className="lt-count">{total} kayıt</span>
      </Toolbar>

      <ListTable
        storageKey="admin-payments"
        head={[
          { label: 'Tarih', width: 120 },
          { label: 'Sipariş No', width: 210 },
          { label: 'Bayi', width: 260 },
          { label: 'Banka', width: 190 },
          { label: 'Tutar', width: 120, right: true },
          { label: 'Durum', width: 130 },
          { label: 'İşlem', width: 100, right: true },
        ]}
        empty={rows.length === 0 ? <div className="lt-empty">Kayıt bulunamadı.</div> : undefined}
        pager={<Pager page={page} pages={pages} total={total} onPage={setPage} />}
      >
        {rows.map((p) => {
          const d = dCell(p.created_at);
          return (
            <tr key={p.id}>
              <td><div className="lt-date">{d.date}<small>{d.time}</small></div></td>
              <td className="lt-oid" title={p.order_id}>{p.order_id}</td>
              <td><CustomerCell primary={p.user_company || p.user_name || 'Bayi'} /></td>
              <td><BankCell bankKey={p.bank_key} /></td>
              <td className="lt-amt">{money(p.amount)}</td>
              <td><StatusPill status={p.status} /></td>
              <td>
                <div className="lt-acts">
                  <ActBtn icon="view" title="Detay" onClick={() => setDetailOrder(p.order_id)} />
                  {isAdmin && <ActBtn icon="trash" tone="danger" title="Sil" onClick={() => remove(p)} disabled={busy === p.id} />}
                </div>
              </td>
            </tr>
          );
        })}
      </ListTable>

      <PaymentDetailModal orderId={detailOrder} onClose={() => setDetailOrder(null)} />
    </div>
  );
}
